import phoneCountryData from '../data/phone-countries.json'
import type { PhoneCountryOption } from '../types/phone.types'

const mappedCountries: PhoneCountryOption[] = (phoneCountryData as PhoneCountryOption[])
    .map((country) => ({
        code: country.code,
        title: country.title,
        dialCode: country.dialCode,
        flag: country.flag ?? '🏳️',
        flagEmoji: country.flag ?? '🏳️',
        flagSrc: country.flagSrc,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));

export function usePhoneCountries() {
    return {
        countries: mappedCountries,
        isLoading: false,
        error: null as unknown,
    };
}
